import {ReactNode} from 'react'
import {MESSAGE_TYPE, MessageContent, MessageItemCommonProps, SENDER_TYPE} from '../../definitions'
import clsx from 'clsx'
import {MessageReactions} from './MessageReactions'

export type MessageItemWrapperProps = MessageItemCommonProps<MessageContent> & {
  children: ReactNode
  wrapperClassName?: string
}

export const MessageItemWrapper = ({
  message,
  className = '',
  wrapperClassName = '',
  children,
}: MessageItemWrapperProps) => {
  return (
    <div
      className={clsx(
        {
          'align-self-end': message?.sender === SENDER_TYPE.USER,
          'align-self-start': message?.sender === SENDER_TYPE.ASSISTANT,
        },
        wrapperClassName
      )}
    >
      <div
        className={clsx(
          'p-4 rounded-3 text-break white-space-pre-wrap position-relative',
          {
            'bg-primary-200 text-white': message?.sender === SENDER_TYPE.USER,
            'bg-light-primary text-gray-900': message?.sender === SENDER_TYPE.ASSISTANT,
          },
          className
        )}
      >
        {children}
      </div>
      {message.type === MESSAGE_TYPE.SURVEY && (
        <MessageReactions className='justify-content-end mt-1' message={message} />
      )}
    </div>
  )
}
